import React from 'react'
import Logo from '../../assets/logo.png';
import { Form } from "@unform/web";
import Input from '../../components/Input/input';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { useNavigate } from "react-router-dom";
import './styles.scss'

export default function User() {

  const MySwal = withReactContent(Swal)

  const navigate = useNavigate();


  function handleSubmit(data, { reset }) {
    console.log(process.env.REACT_APP_USER);

    if ( data.User === process.env.REACT_APP_USER.toString() && data.Password === process.env.REACT_APP_KEY) {
      console.log(process.env.REACT_APP_USER)
      navigate('/manager');
    } else {
      MySwal.fire(
        'Erro!',
        'Ususário ou senha incorretos.',
        'error'
      )
    }

    reset();
  }

  return (
    <div className='main'>
        <img src={Logo} alt="Logo" /> 
        <div className='content' >
        <Form className='form' onSubmit={handleSubmit}>

          <Input name="User" label="User" />
          <Input name="Password" label="Password" type="password" />
          <button type="submit">Login</button>
        </Form>
        </div>
    </div>
  )
}
